import { render, staticRenderFns } from "./CheckboxComponent.vue?vue&type=template&id=6ccfe672&"
import script from "./CheckboxComponent.vue?vue&type=script&lang=ts&"
export * from "./CheckboxComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ccfe672')) {
      api.createRecord('6ccfe672', component.options)
    } else {
      api.reload('6ccfe672', component.options)
    }
    module.hot.accept("./CheckboxComponent.vue?vue&type=template&id=6ccfe672&", function () {
      api.rerender('6ccfe672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/Elements/CheckboxComponent.vue"
export default component.exports